import React from 'react'

const HysteresisImg = () => (
  <span className="hysteresis-image">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <path
        className="edge-image-path"
        fill="#07070F"
        fillOpacity=".87"
        fillRule="evenodd"
        d="M1 15.5a.5.5 0 1 1 0-1h3.5V4A3.5 3.5 0 0 1 7.808.505L8 .5h7a.5.5 0 0 1 .492.41L15.5 1a.5.5 0 0 1-.5.5h-3.5V12a3.5 3.5 0 0 1-3.308 3.495L8 15.5H5zm9.5-14H8A2.5 2.5 0 0 0 5.5 4v10.5H8a2.5 2.5 0 0 0 2.495-2.336L10.5 12V1.5z"
      />
    </svg>
  </span>
)

export default HysteresisImg
